import { render, staticRenderFns } from "./FeaturesTiles.vue?vue&type=template&id=fa053152&"
import script from "./FeaturesTiles.vue?vue&type=script&lang=js&"
export * from "./FeaturesTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports